export function exec(exp) {
    let result = null;
    try {
        result = window.eval(exp);
    }
    catch (e) { }
    return result;
}
//# sourceMappingURL=eval.js.map